import { ComputerIcon, ConsoleIcon } from '@smartshell/ui-kit';

import { BilliardIcon, BoardGameIcon, RacingSimIcon, VrIcon } from 'components';
import { EHostType } from 'types';

export const getHostTypeIcon = (type: EHostType | undefined): JSX.Element => {
  switch (type) {
    case EHostType.PC:
      return <ComputerIcon />;
    case EHostType.CONSOLE:
      return <ConsoleIcon />;

    case EHostType.VR:
      return <VrIcon width={24} height={24} />;
    case EHostType.RACING_SIM:
      return <RacingSimIcon width={24} height={24} />;
    case EHostType.BILLIARD:
      return <BilliardIcon width={24} height={24} />;
    case EHostType.BOARD_GAME:
      return <BoardGameIcon width={24} height={24} />;
    default:
      return <ComputerIcon />;
  }
};
